import request from '@/utils/request.js'
import qs from 'qs';

/***获取所有代理商***/
export function getAllAgentOpts(data){
    return request({
        url: 'agent/all/list',
        method: 'post',
        data
    })
}
/***获取直属下级代理商***/
export function getNextAgentOpts(data){
    return request({
        url: 'agent/next/agent/list',
        method: 'post',
        data
    })
}
/***获取供应商***/
export function getSupplierOpts(data){
    return request({
        url: 'simSupplier/list',
        method: 'post',
        data
    })
}
/***获取自定义套餐***/
export function getPackageOpts(data){
    return request({
        url: 'pkg/list/select',
        method: 'post',
        data
    })
}
/***获取某个代理商拥有的流量池***/
export function getFluxPoolOpts(data){
    return request({
        url: 'simPool/agent/pools',
        method: 'post',
        data
    })
}
